__turbopack_context__.v({
  "contentWrapper": "navDropdownSection-module-scss-module__JLeOKa__contentWrapper",
  "ctaButton": "navDropdownSection-module-scss-module__JLeOKa__ctaButton",
  "ctaSection": "navDropdownSection-module-scss-module__JLeOKa__ctaSection",
  "entityListSection": "navDropdownSection-module-scss-module__JLeOKa__entityListSection",
  "grid-container": "navDropdownSection-module-scss-module__JLeOKa__grid-container",
  "tileSection": "navDropdownSection-module-scss-module__JLeOKa__tileSection",
});
